module.exports = __webpack_public_path__ + "img/IAR10.a1b65e5d.png";